import { getCookie, setCookie } from './utils';

export default function () {
	const cookieAcceptanceKey = 'jpcka';
	const cookieBarOuter = document.getElementById('cookie-bar-outer');
	const cookieBarButtonAll = document.getElementById('cookie-bar-button-all');
	const cookieBarButtonAllBottom = document.getElementById('cookie-bar-button-all-bottom');
	const cookieBarButtonSelected = document.getElementById('cookie-bar-button-save-selected');
	const cookieBarButtonNecessary = document.getElementById('cookie-bar-button-necessary');
	let acceptedCookies = {};

	function cookieAcceptAll() {
		acceptedCookies.s = 1;
		acceptedCookies.b = 1;
		acceptedCookies.a = 1;
		acceptedCookies.r = 1;
		acceptedCookies.f = 1;
		acceptedCookies.m = 1;
		acceptedCookies.g = 1;
		acceptedCookies.p = 1;
		acceptedCookies.t = 1;
		setCookie(cookieAcceptanceKey, JSON.stringify(acceptedCookies), 315360000); // 10 years
		cbJsVariableObject = acceptedCookies;
		cbJsVariable = JSON.stringify(acceptedCookies);

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'cookiebar',
			eventCategory: 'cookiebar',
			eventAction: 'all'
		});
	}

	function redrawButtons(s, b, a, r, f, m, g, p, t) {
		acceptedCookies.s = s;
		acceptedCookies.b = 1;
		acceptedCookies.a = a;
		acceptedCookies.r = r;
		acceptedCookies.f = f;
		acceptedCookies.m = m;
		acceptedCookies.g = g;
		acceptedCookies.p = p;
		acceptedCookies.t = t;
	}

	function cookieAcceptNecessary(s, b, a, r, f, m, g, p, t) {
		acceptedCookies.s = s;
		acceptedCookies.b = b;
		acceptedCookies.a = a;
		acceptedCookies.r = r;
		acceptedCookies.f = f;
		acceptedCookies.m = m;
		acceptedCookies.g = g;
		acceptedCookies.p = p;
		acceptedCookies.t = t;
		setCookie(cookieAcceptanceKey, JSON.stringify(acceptedCookies), 2592000); // 30 days
		cbJsVariableObject = acceptedCookies;
		cbJsVariable = JSON.stringify(acceptedCookies);

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'cookiebar',
			eventCategory: 'cookiebar',
			eventAction: 'necessary'
		});
	}

	function cookieAcceptSelected() {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'cookiebar',
			eventCategory: 'cookiebar',
			eventAction: 'custom'
		});
		if (Object.keys(acceptedCookies).length === 0 && !getCookie(cookieAcceptanceKey).length) {
			redrawButtons(0, 1, 0, 0, 0, 0, 0, 0, 0);
		} else if (Object.keys(acceptedCookies).length === 0 && getCookie(cookieAcceptanceKey).length) {
			acceptedCookies = JSON.parse(getCookie(cookieAcceptanceKey));
		}
		setCookie(cookieAcceptanceKey, JSON.stringify(acceptedCookies), 315360000); // 10 years
		cbJsVariableObject = acceptedCookies;
		cbJsVariable = JSON.stringify(acceptedCookies);
	}

	function showCookieBar() {
		if (cookieBarOuter) {
			cookieBarOuter.style.visibility = 'visible';
			cookieBarOuter.style.display = 'initial';
		}
	}

	function hideCookieBar() {
		if (cookieBarOuter) {
			cookieBarOuter.style.visibility = 'hidden';
			cookieBarOuter.style.display = 'none';
		}
	}

	function locationReload() {
		if (document.querySelectorAll('main.page-content .cookiesOutCont').length) {
			location.reload();
		}
	}

	function checkCookieAcceptance() {
		if (getCookie(cookieAcceptanceKey) === '') {
			showCookieBar();
		} else {
			if (cookieBarOuter) {
				hideCookieBar();
			}
		}
	}

	if (cookieBarButtonAll) {
		cookieBarButtonAll.addEventListener('click', function () {
			hideCookieBar();
			setTimeout(() => {
				cookieAcceptAll();
				locationReload();
			}, 1);
		});
	}

	if (cookieBarButtonAllBottom) {
		cookieBarButtonAllBottom.addEventListener('click', function () {
			hideCookieBar();
			setTimeout(() => {
				cookieAcceptAll();
				locationReload();
			}, 1);
		});
	}

	if (cookieBarButtonNecessary) {
		cookieBarButtonNecessary.addEventListener('click', function () {
			hideCookieBar();
			setTimeout(() => {
				cookieAcceptNecessary(0, 1, 0, 0, 0, 0, 0, 0, 0);
				locationReload();
			}, 1);
		});
	}

	if (cookieBarButtonSelected) {
		cookieBarButtonSelected.addEventListener('click', function () {
			hideCookieBar();
			setTimeout(() => {
				cookieAcceptSelected();
				locationReload();
			}, 1);
		});
	}

	if (document.querySelectorAll('.cookiesInCont').length && !getCookie(cookieAcceptanceKey).length) {
		redrawButtons(0, 1, 0, 0, 0, 0, 0, 0, 0);
	}

	document.querySelectorAll('.openCaptionCookies').forEach(function (element) {
		element.addEventListener('click', function () {
			element.classList.toggle('openCaption');
			element.closest('.cookiesOutCont').querySelector('.captionCookie').classList.toggle('openCaption');
		});
	});

	const cookieBarButtonOpen = document.getElementById('cookie-bar-button-open');
	if (cookieBarButtonOpen) {
		document.getElementById('cookie-bar-button-open').addEventListener('click', function () {
			document.querySelector('.extendCont').classList.toggle('openCont');
		});
	}

	if (getCookie(cookieAcceptanceKey).length) {
		const sett = JSON.parse(getCookie(cookieAcceptanceKey));
		Object.entries(sett).forEach(function ([key, value]) {
			document
				.querySelectorAll('.cookiesInCont .button[data-button="' + key + '"][data-value="' + value + '"]')
				.forEach(function (element) {
					element.classList.add('disableButt');
					element.textContent = element.getAttribute('data-caption');
				});
		});
	} else {
		redrawButtons(0, 1, 0, 0, 0, 0, 0, 0, 0);
		Object.entries(acceptedCookies).forEach(function ([key, value]) {
			document
				.querySelectorAll('.cookiesInCont .button[data-button="' + key + '"][data-value="' + value + '"]')
				.forEach(function (element) {
					element.classList.add('disableButt');
					element.textContent = element.getAttribute('data-caption');
				});
		});
	}

	let isClicked = false;
	document.querySelectorAll('.cookiesInCont .button').forEach(function (button) {
		button.addEventListener('click', function (e) {
			if (button.classList.contains('disableButt')) {
				e.preventDefault();
				return false;
			}

			if (getCookie(cookieAcceptanceKey).length && !isClicked) {
				const sett = JSON.parse(getCookie(cookieAcceptanceKey));
				Object.entries(sett).forEach(function ([key, value]) {
					acceptedCookies[key] = value;
				});
			}
			isClicked = true;
			const btn = button.getAttribute('data-button');
			const val = button.getAttribute('data-value');
			acceptedCookies[btn] = val * 1;
			redrawButtons(
				acceptedCookies.s,
				1,
				acceptedCookies.a,
				acceptedCookies.r,
				acceptedCookies.f,
				acceptedCookies.m,
				acceptedCookies.g,
				acceptedCookies.p,
				acceptedCookies.t
			);

			button.classList.toggle('disableButt');
			button.textContent = button.getAttribute('data-caption');
			let oldCaption = val === '0' ? 'Povolit' : 'Zakázat';

			const siblings = Array.from(button.parentNode.children).filter(function (sibling) {
				return sibling !== button && sibling.hasAttribute('data-button');
			});

			siblings.forEach(function (sibling) {
				sibling.classList.remove('disableButt');
				sibling.textContent = oldCaption;
			});
		});
	});

	checkCookieAcceptance();
}
